import { render, staticRenderFns } from "./PurchaseOrderAdd.vue?vue&type=template&id=47d30308"
import script from "./PurchaseOrderAdd.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports